import React from 'react';
import { Link } from 'react-router-dom';

export default function Salvation() {
  return (
    <>
      {/* Hero banner */}
      <section className="salvation-hero">
        <div className="inner" style={{ textAlign: 'center', maxWidth: 800 }}>
          <div className="section-label center">The Most Important Question You'll Ever Answer</div>
          <h1 className="section-title" style={{ fontSize: 'clamp(2.2rem, 5vw, 3.5rem)', marginBottom: '1.5rem' }}>
            How to Be Saved
          </h1>
          <p style={{ fontSize: '1.1rem', lineHeight: 1.9, color: 'rgba(245,240,232,.8)', maxWidth: 600, margin: '0 auto 2rem' }}>
            The Bible gives a clear answer. No confusion. No complexity. Just the truth.
          </p>
          <blockquote className="sal-hero-verse">
            "Jesus saith unto him, I am the way, the truth, and the life: no man cometh unto the Father, but by me."
            <cite>John 14:6</cite>
          </blockquote>
        </div>
      </section>

      <div className="divider" />

      {/* Step I */}
      <section style={{ background: 'linear-gradient(180deg, var(--navy), var(--deep-blue))' }}>
        <div className="inner">
          <div className="sal-step">
            <div className="sal-numeral">I</div>
            <h2 className="sal-heading">You Are Guilty Before a Holy God</h2>
            <p className="sal-body">
              The Bible is clear: sin is the breaking of God's law, and every one of us has done it. God is holy, just, and true, and His standard is perfection. When measured against that standard, all men fall short.
            </p>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"As it is written, There is none righteous, no, not one."</p>
              <p className="sal-verse-ref">Romans 3:10</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"For all have sinned, and come short of the glory of God."</p>
              <p className="sal-verse-ref">Romans 3:23</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"For there is not a just man upon earth, that doeth good, and sinneth not."</p>
              <p className="sal-verse-ref">Ecclesiastes 7:20</p>
            </div>
            <p className="sal-body">
              God says plainly that anyone who claims to be without sin is calling Him a liar. The verdict has already been given: all are guilty.
            </p>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* Step II */}
      <section style={{ background: 'var(--deep-blue)' }}>
        <div className="inner">
          <div className="sal-step">
            <div className="sal-numeral">II</div>
            <h2 className="sal-heading">Sin Has Separated You from God</h2>
            <p className="sal-body">
              Sin is not a small flaw or a harmless mistake. It creates a real separation between man and God. Because God is righteous, sin places us at odds with Him and leaves us unable to stand before His judgment or enter His presence.
            </p>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"But your iniquities have separated between you and your God."</p>
              <p className="sal-verse-ref">Isaiah 59:2</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"Therefore the ungodly shall not stand in the judgment."</p>
              <p className="sal-verse-ref">Psalm 1:5</p>
            </div>
            <p className="sal-body">
              Left to ourselves, we have no answer for our sin and no way to bridge the gap it has created. That is why effort, morality, and religion are not enough.
            </p>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Step III */}
      <section style={{ background: 'linear-gradient(180deg, var(--deep-blue), var(--navy))' }}>
        <div className="inner">
          <div className="sal-step">
            <div className="sal-numeral">III</div>
            <h2 className="sal-heading">Jesus Christ Is God's Only Answer</h2>
            <p className="sal-body">
              God did not leave mankind without hope. The Creator stepped into His own creation. The eternal Word became flesh, was born of a virgin, lived without sin, and willingly laid down His life to pay the full price for sin.
            </p>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"For unto you is born this day in the city of David a Saviour, which is Christ the Lord."</p>
              <p className="sal-verse-ref">Luke 2:11</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"Who his own self bare our sins in his own body on the tree."</p>
              <p className="sal-verse-ref">1 Peter 2:24</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"For Christ also hath once suffered for sins, the just for the unjust, that he might bring us to God."</p>
              <p className="sal-verse-ref">1 Peter 3:18</p>
            </div>
            <p className="sal-body">
              No church can remove sin. No priest, pope, ritual, ordinance, or good work can cleanse the soul. Only Jesus Christ shed blood for sinners, and only He rose from the dead victorious. Salvation is found in a Person, not a system.
            </p>
          </div>
        </div>
      </section>

      <div className="divider divider-gold" />

      {/* Step IV */}
      <section style={{ background: 'var(--navy)' }}>
        <div className="inner">
          <div className="sal-step">
            <div className="sal-numeral">IV</div>
            <h2 className="sal-heading">Will You Believe on the Lord Jesus Christ?</h2>
            <p className="sal-body">
              Salvation is not earned. It is received. God promises forgiveness and eternal life to those who place their trust entirely in Jesus Christ. God does not promise forgiveness to those who instead choose to trust in themselves, in works, or in religion.
            </p>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"For God so loved the world, that he gave his only begotten Son, that whosoever believeth in him should not perish, but have everlasting life."</p>
              <p className="sal-verse-ref">John 3:16</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"That if thou shalt confess with thy mouth the Lord Jesus, and shalt believe in thine heart that God hath raised him from the dead, thou shalt be saved. For with the heart man believeth unto righteousness; and with the mouth confession is made unto salvation."</p>
              <p className="sal-verse-ref">Romans 10:9-10</p>
            </div>
            <p className="sal-body" style={{ marginTop: '1.5rem' }}>There is no alternative path.</p>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"Jesus saith unto him, I am the way, the truth, and the life: no man cometh unto the Father, but by me."</p>
              <p className="sal-verse-ref">John 14:6</p>
            </div>
            <div className="sal-verse-block">
              <p className="sal-verse-text">"Neither is there salvation in any other."</p>
              <p className="sal-verse-ref">Acts 4:12</p>
            </div>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Final Appeal */}
      <section className="sal-final">
        <div className="inner" style={{ textAlign: 'center', maxWidth: 750 }}>
          <h2 className="sal-final-heading">Every Person Will Die, and Every Soul Will Stand Before God.</h2>
          <div className="sal-verse-block" style={{ textAlign: 'center' }}>
            <p className="sal-verse-text">"And as it is appointed unto men once to die, but after this the judgment."</p>
            <p className="sal-verse-ref">Hebrews 9:27</p>
          </div>

          <p className="sal-what-if">What if that appointment were today?</p>

          <div className="sal-summary">
            <p>You now know what God has said:</p>
            <ul>
              <li>You are a sinner</li>
              <li>You need a Saviour</li>
              <li>Jesus Christ is that Saviour</li>
            </ul>
          </div>

          <p className="sal-final-question">
            The only question left is this:<br />
            <strong>Will you believe on Him now?</strong>
          </p>

          <div className="sal-verse-block" style={{ textAlign: 'center' }}>
            <p className="sal-verse-text">"Behold, now is the accepted time; behold, now is the day of salvation."</p>
            <p className="sal-verse-ref">2 Corinthians 6:2</p>
          </div>
          <div className="sal-verse-block" style={{ textAlign: 'center' }}>
            <p className="sal-verse-text">"How shall we escape, if we neglect so great salvation?"</p>
            <p className="sal-verse-ref">Hebrews 2:3</p>
          </div>

          <div style={{ marginTop: '3rem' }}>
            <Link to="/bible/43/1" className="btn-p">Read the Gospel of John</Link>
          </div>
        </div>
      </section>
    </>
  );
}
